import React, { FC, useRef, useEffect, useState } from 'react';
import { graphql } from 'gatsby';
import ImageWithFallback from '../ImageWithFallback';
import {
  StyledSection,
  StyledContentBlock,
  MainContainer,
  MainContentWrapper,
  Title,
  Text,
  ContentContainer,
  ImageSection,
  ImageWrapper,
  Video,
  ContentSection,
  CardContainer,
  CardImageWrapper,
  CardContentContanier,
  CardTitle,
  CardText,
  ContentSectionMobile,
  CardContainerMobile,
  CardContentContanierMobile,
} from './styled';

interface Props {
  hasScrolled: boolean;
  showVideo: boolean;
}

const Guide: FC<Props & Queries.SeoGuideFragment> = ({
  guide,
  hasScrolled,
  showVideo,
}) => {
  const { title, subtitle, image,steps } = guide || {};
  const videoRef = useRef(null);
  const [videoSrc, setVideoSrc] = useState('/images/uploads/buy-crypto.webm');
  // console.log('videoSrc', videoSrc, showVideo, hasScrolled, videoRef);

  useEffect(() => {
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) {
      setVideoSrc('/images/uploads/buy-crypto.mp4');
    } else {
      setVideoSrc('/images/uploads/buy-crypto.webm');
    }
  }, []);

  return (
    <StyledSection>
      <StyledContentBlock>
        <MainContainer>
          <MainContentWrapper>
            <Title>{title}</Title>
            <Text>{subtitle}</Text>
          </MainContentWrapper>
          <ContentContainer>
            <ImageSection>
              {/* {(!hasScrolled || !showVideo) && (
                <ImageWrapper>
                  <ImageWithFallback
                    src={image?.src}
                    alt={image?.alt}
                  />
                </ImageWrapper>
              )}  */}
             {hasScrolled && (
                <Video
                  ref={videoRef}
                  autoPlay
                  preload="auto"
                  loop
                  muted
                  playsInline
                  disablePictureInPicture
                  display={showVideo ? 'block' : 'none'}
                >
                  {videoSrc && (
                    <source
                      src={videoSrc}
                      type={
                        videoSrc.endsWith('.webm') ? 'video/webm' : 'video/mp4'
                      }
                    />
                  )}
                  <ImageWrapper>
                    <ImageWithFallback
                      src={image?.src}
                      alt={image?.alt}
                    />
                  </ImageWrapper> 
                </Video>
              )}
            </ImageSection>
            {steps && (
              <ContentSection>
                {steps.map(step => (
                  <CardContainer key={step?.title}>
                    <CardImageWrapper>
                      <ImageWithFallback
                        src={step?.image}
                        alt={step?.title}
                      />
                    </CardImageWrapper>
                    <CardContentContanier>
                      <CardTitle>{step?.title}</CardTitle>
                      <CardText>{step?.description}</CardText>
                    </CardContentContanier>
                  </CardContainer>
                ))}
              </ContentSection>
            )}
            {steps && (
              <ContentSectionMobile>
                {steps.map(step => (
                  <CardContainerMobile key={step?.title}>
                    <CardContentContanierMobile>
                      <CardImageWrapper>
                        <ImageWithFallback
                          src={step?.image}
                          alt={step?.title}
                        />
                      </CardImageWrapper>
                      <CardTitle>{step?.title}</CardTitle>
                    </CardContentContanierMobile>
                    <CardText>{step?.description}</CardText>
                  </CardContainerMobile>
                ))}
              </ContentSectionMobile>
            )}
          </ContentContainer>
        </MainContainer>
      </StyledContentBlock>
    </StyledSection>
  );
};
export const query = graphql`
  fragment SeoGuide on Json {
    guide {
      title
      subtitle
      image {
        src
        alt
      }
      steps {
        title
        description
        image
      }
    }
  }
`;

export default Guide;
